import { services } from "./services";

/** Display order for mega-menu columns */
const CATEGORY_ORDER = ["Development", "Design", "Cloud"];

function categorySlug(category) {
  return String(category || "")
    .toLowerCase()
    .replace(/\s+/g, "-");
}

/**
 * Group published services for the header mega menu (same catalogue as /service/:slug).
 */
export function getNavServiceCategories() {
  const by = new Map();
  for (const s of services) {
    const c = s.category || "Development";
    if (!by.has(c)) by.set(c, []);
    by.get(c).push(s);
  }
  return CATEGORY_ORDER.filter((c) => by.has(c)).map((c) => ({
    id: categorySlug(c),
    category: c,
    items: by.get(c),
  }));
}
